import noodleApiClient from '@/tsClient/servers/noodleApi';
import type { CaseDataResponse } from '@/typings/api-models';

type Input = {
  caseId: string;
};

const getCaseData = async ({ caseId }: Input): Promise<CaseDataResponse> => {
  const response = await noodleApiClient.get(`/cases/${caseId}`);
  return response.data as CaseDataResponse;
};

export default getCaseData;
